import React, { createContext, useContext } from 'react';
import {
  ArticleRichTextLayoutBlockProps,
  ArticleRichTextLayoutBlockStyleProps,
} from '../components/ArticleRichText/ArticleRichTextLayoutBlock/ArticleRichTextLayoutBlock';

const ArticleRichTextLayoutBlockContext = createContext<ArticleRichTextLayoutBlockStyleProps>({});

export const ArticleRichTextLayoutBlockContextProvider = ({ children, ...props }: ArticleRichTextLayoutBlockProps) => (
  <ArticleRichTextLayoutBlockContext.Provider value={props}>{children}</ArticleRichTextLayoutBlockContext.Provider>
);

export const useArticleRichTextLayoutBlockProps = ():
  | ArticleRichTextLayoutBlockStyleProps
  | Record<string, unknown> => {
  return useContext(ArticleRichTextLayoutBlockContext) ?? {};
};
